import { useProductPromotion } from "@/Apollo/hooks/promotions/useProductPromotion";
import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { isProductCurated } from "@/common/utils/product.utils";
import ProductUtils from "@/components/ProductDetail/utils/ProductUtils";
import { ProductLabelList } from "@/components/product/ProductLabelList";
import { usePdpReservation } from "@/features/pro-buyer-reservations/hooks/usePdpReservation";

type ProductDetailsInfoTagsProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoTags = ({
  product,
}: ProductDetailsInfoTagsProps) => {
  const promotion = useProductPromotion(product.id, product.slug ?? "");
  const reservation = usePdpReservation(product.id, !!product.isOwner);

  return (
    <ProductLabelList
      curated={isProductCurated(product)}
      boosted={Boolean(product.isBoosted)}
      showroom={ProductUtils.isInShowroom(product)}
      reserved={reservation.mode === "others"}
      paidLabel={promotion?.label?.text}
    />
  );
};
